<template>
  <div class="c-form-select">
    <label
      class="c-form-select__label"
      v-bind:class="requiredCssClass"
      v-bind:for="id">
      {{ label }}
    </label>
    <select
      class="c-form-select__control"
      v-bind="$attrs"
      v-bind:aria-describedby="errorId"
      v-bind:id="id"
      v-bind:value="value"
      v-on:change="updateValue">
      <option value="">Please select an option</option>
      <option
        v-bind:key="option.value"
        v-bind:selected="option.value === value"
        v-bind:value="option.value"
        v-for="option in options">
        {{ option.label }}
      </option>
    </select>
    <span
      class="c-form-input__validation-message"
      v-bind:id="errorId"
      v-if="validationError">
      {{ validationMessage }}
    </span>
  </div>
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    id: {
      required: true,
      type: String,
    },
    label: {
      required: true,
      type: String,
    },
    options: {
      required: true,
      type: Array,
    },
    required: {
      default: false,
      required: false,
      type: Boolean,
    },
    validationError: {
      default: false,
      required: false,
      type: Boolean,
    },
    validationMessage: {
      required: false,
      type: String,
    },
    value: {
      type: [String, Number],
    },
  },
  computed: {
    errorId() {
      return `${this.id}ErrorMsg`;
    },
    requiredCssClass() {
      return this.required ? 'c-form-select__label--required' : '';
    },
  },
  methods: {
    updateValue(event) {
      this.$emit('change', event.target.value);
    },
  },
}
</script>


// WEBPACK FOOTER //
// src/components/components/geneco/resources/form/elements/FormSelect.vue